
  import { mapActions, mapGetters, mapState } from 'vuex'

  import { ListingFilter } from '@loavies/c2c-models'

  import AppButton from '@loavies/component-library/dist/app-button'
  import AppPopover from '@loavies/component-library/dist/app-popover'
  import IconFilterBorderless from '@loavies/component-library/dist/icons/icon-filter-borderless'
  import IconArrowDownBorderless from '@loavies/component-library/dist/icons/icon-arrow-down-borderless'
  import IconArrowUpBorderless from '@loavies/component-library/dist/icons/icon-arrow-up-borderless'

  export default {
    components: {
      AppButton,
      AppPopover,
      IconFilterBorderless,
      IconArrowDownBorderless,
      IconArrowUpBorderless,
    },
    props: {
      filter: {
        type: ListingFilter,
        default: null,
      },
      sorting: {
        type: Boolean,
        default: false,
      },
      priceFilters: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        toggleIsOpen: false,
      }
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        activePriceFilters: state => state.listings.activePriceFilters,
      }),
      ...mapGetters({
        getActiveFilterOptionCount: 'listings/getActiveFilterOptionCount',
        defaultSortOptionIsActive: 'listings/defaultSortOptionIsActive',
      }),
      activePriceFiltersCount() {
        return this.activePriceFilters.length
      },
      activeFilterOptionsCount() {
        if (this.filter) {
          return this.getActiveFilterOptionCount(this.filter)
        }

        if (this.priceFilters) {
          return this.activePriceFiltersCount
        }

        return 0
      },
      arrowComponent() {
        return this.toggleIsOpen ? 'IconArrowUpBorderless' : 'IconArrowDownBorderless'
      },
      resetButtonText() {
        return this.activeFilterOptionsCount
          ? `${this.$t('reset')} (${this.activeFilterOptionsCount})`
          : this.$t('reset')
      },
    },
    methods: {
      ...mapActions({
        deleteActiveFilter: 'listings/deleteActiveFilter',
        resetActivePriceFilters: 'listings/resetActivePriceFilters',
        setDefaultSortOption: 'listings/setDefaultSortOption',
        fetchListingsByActiveFilters: 'listings/fetchListingsByActiveFilters',
      }),
      handleClick() {
        this.$emit('click')
      },
      handlePopoverToggle(toggleIsOpen) {
        this.toggleIsOpen = toggleIsOpen
      },
      resetFilter() {
        if (this.filter) {
          this.deleteActiveFilter(this.filter)
        }

        if (this.priceFilters) {
          this.resetActivePriceFilters({ resetQueryString: true })
          this.fetchListingsByActiveFilters()
        }

        if (this.sorting) {
          this.setDefaultSortOption()
        }

        this.closePopover()
      },
      closePopover() {
        this.$refs.popover.toggleDialog()
      },
    },
  }
